import React from "react"

import SEO from "../../components/wild/global/seo"
import ProductOptionsSchema from "../../components/wild/global/productoptionsschema"
import CoreProduct from "../../components/wild/nova/product/core/coreproduct"

import { data } from "../../data/nutrafol-core-for-women-nova"
import { meshProductDataV2 } from "../../utils/productloader"
import { useContentfulFaq } from "../../hooks/useContentfulFaq"

const NutrafolCoreForWomen = (props) => {
  const mageProducts = props.pageContext.products
  const meshedProductData = meshProductDataV2(
    JSON.parse(JSON.stringify(mageProducts)),
    data
  )
  const cfFaqData = useContentfulFaq()
  
  return (
    <>
      <SEO
        title={meshedProductData.seo.title}
        description={meshedProductData.seo.description}
      />
      <ProductOptionsSchema options={meshedProductData.atcAreaData.options} />
      <CoreProduct
        cfFaqData={cfFaqData?.["#womens-pdp"]}
        data={{
          ...meshedProductData,
          atcAreaData: {
            ...meshedProductData.atcAreaData,
          },
        }}
        location={props.location.pathname}
      />
    </>
  )
}

export default NutrafolCoreForWomen
